import {
  Button,
  Card,
  Box,
  TextField,
  Grid,
  Typography,
  CircularProgress,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import Connection from '../../../Contract'
import bigInt from 'big-integer'
import loader from '../../../Image/graphics-07.gif'
import { toast, ToastContainer } from 'react-toastify'
import { useWeb3Context } from '../../../hooks/web3Context'

const ValidatorInfo = () => {
  const location = useLocation()
  const getDetails = location.state.details
  const [delegatorsList, getDelegatorsList] = useState()
  let [account, setAccount] = useState()
  const [loading, setLoading] = useState(false)
  const [transactionSuccess, setTransactionsSuccess] = useState(false)
  const [showAmountWarning, setShowamountWarning] = useState(false)
  const [validatorsDetailsLocal, setValidatorDetailsLocal] = useState({})

  useEffect(() => {
    listOfActive()
    getValidatorInfoDetails()
  }, [])

  const listOfActive = async () => {
    try {
      let listactdata = await Connection.getActiveValidators()
      getDelegatorList(listactdata)
    } catch (error) { }
  }

  const getDelegatorList = async (list) => {
    try {
      for (let i = 0; i < list.length; i++) {
        let listdata = await Connection.getValidatorInfo(list[i])
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getAccounts = async () => {
    try {
      account = await window.ethereum.selectedAddress;
      setAccount(account);
    }
    catch (error) {
      console.log(error)
    }
  };

  try {
    window.ethereum.on("accountsChanged", function () {
      getAccounts();
    });
  } catch (error) {
    console.log(error)
  }

  useEffect(() => {
    getAccounts();
  }, []);

  const delegateStake = async (details) => {
    console.log('dklsdhskhdsjk', price)
    if (price <= 0) {
      console.log('ifff')
      setShowamountWarning(true)
      return null
    }
    try {
      setLoading(true)

      let stakerAmountData = bigInt(price * 10 ** 18)
      console.log(stakerAmountData.value)
      let deligate = await Connection.stakeDelegator(details.address, {
        value: stakerAmountData.value,
      })
      console.log(deligate, 'deligate')
      let abc = await deligate.wait()
      if (abc) {
        setLoading(false)
        toast.success('Stake successfull!')
        setShowamountWarning(false)
      }
      setPrice('')
    } catch (error) {
      setLoading(false)
      console.log(error)
      if (error.code === 4001) {
        toast.error(error.message.split(':').pop())
      } else if (error.error.data.message) {
        toast.error(error.error.data.message)
      }
    }
  }

  const [price, setPrice] = React.useState(0)
  // const handleChange = (event) => {
  //   setName(event.target.value);
  // };
  const getValidatorInfoDetails = () => {
    if (getDetails) {
      var requestOptions = {
        method: 'GET',
        redirect: 'follow',
      }

      fetch(
        `https://api.dexit.network/validatorInfo/${getDetails.address.toLowerCase()}`,
        requestOptions,
      )
        .then((response) => response.text())
        .then((result) => {
          setValidatorDetailsLocal(JSON.parse(result))
        })
        .catch((error) => console.log('error', error))
    }
  }

  return (
    <div>
      <ToastContainer />

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', padding: '10%' }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              textAlign: 'center',
            }}
          >
            <img src={loader} width={250} height={120} alt="" />
            <span
              style={{ fontSize: '1.2rem', lineHeight: '0', color: 'grey' }}
            >
              Please Wait...
            </span>
          </div>
        </Box>
      ) : (
        <>
          {getDetails ? (
            <>
              <Grid container>
                <Grid xs={12} p={1} mt={3}>
                  <Card
                    className="section-card"
                    sx={{ width: 'auto !important' }}
                  >
                    <Box
                      sx={{
                        flexGrow: 1,
                        width: '100%',
                        '& .MuiTextField-root': { width: '100%' },
                      }}
                      component="form"
                      noValidate
                      autoComplete="off"
                    >
                      <Grid container>
                        <Typography className="header-text">
                          Validator Details
                        </Typography>
                      </Grid>

                      <Grid container mt={1}>
                        <Grid item xs={12} md={4} sx={{ display: 'flex' }}>
                          <Typography color="#FFFFF9">
                            Validator Address
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={8} sx={{ display: 'flex' }}>
                          <TextField
                            id="outlined-name"
                            value={getDetails ? getDetails.address : '-'}
                            InputProps={{
                              readOnly: true,
                            }}
                            size="small"
                            variant="filled"
                            hiddenLabel
                          />
                        </Grid>
                      </Grid>
                      <Grid container mt={1}>
                        <Grid item xs={12} md={4} sx={{ display: 'flex' }}>
                          <Typography color="#FFFFF9">Total Amount</Typography>
                        </Grid>
                        <Grid item xs={12} md={8} sx={{ display: 'flex' }}>
                          <TextField
                            defaultValue="foo"
                            value={
                              getDetails
                                ? getDetails.amount / 1000000000000000000
                                : '-'
                            }
                            InputProps={{
                              readOnly: true,
                            }}
                            size="small"
                            variant="filled"
                            hiddenLabel
                          />
                        </Grid>
                      </Grid>
                      <Grid container mt={1}>
                        <Grid item xs={12} md={4} sx={{ display: 'flex' }}>
                          <Typography color="#FFFFF9">Name</Typography>
                        </Grid>
                        <Grid item xs={12} md={8} sx={{ display: 'flex' }}>
                          <TextField
                            value={
                              validatorsDetailsLocal !== undefined
                                ? validatorsDetailsLocal?.data?.Name
                                : '-'
                            }
                            InputProps={{
                              readOnly: true,
                            }}
                            size="small"
                            variant="filled"
                            hiddenLabel
                          />
                        </Grid>
                      </Grid>
                      <Grid container mt={1}>
                        <Grid item xs={12} md={4} sx={{ display: 'flex' }}>
                          <Typography color="#FFFFF9">Description</Typography>
                        </Grid>
                        <Grid item xs={12} md={8} sx={{ display: 'flex' }}>
                          <TextField
                            defaultValue="foo"
                            value={
                              validatorsDetailsLocal !== undefined
                                ? validatorsDetailsLocal?.data?.Description
                                : '-'
                            }
                            InputProps={{
                              readOnly: true,
                            }}
                            size="small"
                            variant="filled"
                            hiddenLabel
                          />
                        </Grid>
                      </Grid>
                      <Grid container mt={1}>
                        <Grid item xs={12} md={4} sx={{ display: 'flex' }}>
                          <Typography color="#FFFFF9">Website</Typography>
                        </Grid>
                        <Grid item xs={12} md={8} sx={{ display: 'flex' }}>
                          <TextField
                            defaultValue="foo"
                            value={
                              validatorsDetailsLocal !== undefined
                                ? validatorsDetailsLocal?.data?.Website
                                : '-'
                            }
                            InputProps={{
                              readOnly: true,
                            }}
                            size="small"
                            variant="filled"
                            hiddenLabel
                          />
                        </Grid>
                      </Grid>

                      <Grid container mt={1}>
                        <Grid item xs={12} sx={{ display: 'flex' }}>
                          <TextField
                            value="By delegating DXT, you help secure the network. You will receive part of the rewards provided by the protocol for doing so, There is a minimum lock time of 7 days whenever you delegate."
                            InputProps={{
                              readOnly: true,
                            }}
                            size="small"
                            variant="filled"
                            disabled
                            hiddenLabel
                            fullWidth
                            multiline
                            rows={2}
                          />
                        </Grid>
                      </Grid>

                      {/* <TextField
                        id="outlined-uncontrolled"
                        label="Number of Delegators"
                        defaultValue="foo"
                        value={
                          delegatorsList
                            ? Object.keys(delegatorsList).length
                            : '-'
                        }
                        InputProps={{
                          readOnly: true,
                        }}
                      /> */}
                    </Box>
                    <Grid container justifyContent="center">
                      <Grid
                        lg={4}
                        xs={12}
                        mt={2}
                        p={2}
                        sx={{
                          backgroundColor: '#383A4E',
                          borderRadius: '20px',
                        }}
                      >
                        <Typography className="header-text">
                          Delegator Info
                        </Typography>
                        <Card
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            boxShadow: 'none',
                            backgroundColor: 'transparent !important',
                          }}
                        >
                          <Box
                            sx={{
                              flexGrow: 1,
                              '& .MuiTextField-root': { mt: 1, width: '100%' },
                            }}
                            component="form"
                            noValidate
                            autoComplete="off"
                          >
                            <Typography className="input-label">
                              Your Address
                            </Typography>
                            <TextField
                              value={account ? account : '-'}
                              InputProps={{
                                readOnly: true,
                              }}
                              size="small"
                              className="input-label-input"
                              sx={{ mb: 1 }}
                              variant="filled"
                              hiddenLabel
                              fullWidth
                            />
                            <Typography className="input-label">
                              Amount
                            </Typography>
                            <TextField
                              value={price}
                              error={showAmountWarning}
                              onChange={(e) => setPrice(e.target.value)}
                              size="small"
                              variant="filled"
                              className="input-label-input"
                              hiddenLabel
                              fullWidth
                            />
                            <div
                              style={{
                                justifyContent: 'center',
                                display: 'flex',
                              }}
                            >
                              <Button
                                variant="contained"
                                primary
                                sx={{ m: 1 }}
                                onClick={() => delegateStake(getDetails)}
                                size="large"
                              >
                                Delegate
                              </Button>
                            </div>
                          </Box>
                        </Card>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </>
          ) : (
            '-'
          )}
        </>
      )}
    </div>
  )
}

export default ValidatorInfo
